<template>
  <div class="p10 br10 box-s">
    <!-- {{ value }} -->
    <div class="acsa">
      <div v-for="(title, index) in searchConfig" class="p4" :key="index" :style="getColumnStyle(title)">
        {{ title.name }}
      </div>
    </div>
    <draggable v-model="localValue" handle=".search_item">
      <div v-for="(item, index) in localValue" :key="index">
        <div class="acsb p4 mb4 br10" :style="getRowStyle(index)" style="border: 1px #eee solid">
          <!-- {{ item }} -->

          <div v-for="(rowConfig, x) in searchConfig" :key="x" :style="getColumnStyle(rowConfig)" class="p2">
            <div class="fs18 p2" v-if="rowConfig.value == 'option'">
              <i class="el-icon-delete mr6" style="color: red" @click="deleteRow(localValue, rowIndex)"></i>
              <span>
                <i class="el-icon-rank search_item"></i>
              </span>
            </div>

            <el-select v-model="item.event" placeholder="请选择" filterable allow-create v-else-if="rowConfig.value == 'event'">
              <el-option v-for="event in event_options" :key="event.value" :label="event.label" :value="event.value"> </el-option>
            </el-select>

            <div v-else-if="rowConfig.value == 'content'">
              <div v-if="item.type == '按钮单选'" class="ac wrap">
                <div v-for="(content, contentIndex) in item.content" :key="contentIndex">
                  <div class="ac mr4 p2 br4 box-s mb4">
                    <el-input v-model="content.name" placeholder="请输入"></el-input>
                    <i class="el-icon-delete ml4" style="color: red" @click="deleteRow(item.content, contentIndex)"></i>
                  </div>
                </div>

                <el-button type="primary" size="mini" class="ml4" @click="add_to_rows(item.content, {name: ''})">添加</el-button>
              </div>
              <!-- <div class="acsb mt10">
                <div></div>

              </div> -->
            </div>

            <div class="flex1" v-else>
              <el-select v-model="item[rowConfig.value]" placeholder="请选择" filterable v-if="rowConfig.type == 'select'">
                <el-option v-for="(option, oo) in rowConfig.options" :key="oo" :label="option.label" :value="option.value"> </el-option>
              </el-select>

              <el-input v-model="item[rowConfig.value]" v-else placeholder="请输入"></el-input>
            </div>
          </div>
        </div>
      </div>
    </draggable>
    <div class="acsb">
      <div></div>
      <el-button type="primary" size="mini" @click="add_to_rows(localValue, {type: '', content: []})">添加</el-button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import _ from 'lodash'
export default {
  components: {draggable},
  props: {
    value: {
      type: null,
      default: null
    }
  },

  data() {
    const typeOptions = [
      {
        label: '蓝色',
        value: 'primary'
      },
      {
        label: '绿色',
        value: 'success'
      },
      {
        label: '灰色',
        value: 'info'
      },
      {
        label: '橙色',
        value: 'warning'
      },
      {
        label: '红色',
        value: 'danger'
      },
      {
        label: '白色',
        value: ''
      }
    ]
    const btnSize = [
      {
        label: '大号',
        value: ''
      },
      {
        label: '中号',
        value: 'small'
      },

      {
        label: '小号',
        value: 'mini'
      }
    ]
    return {
      localValue: [],
      searchConfig: [
        {
          name: '名称',
          value: 'name',
          width: 120
        },
        {
          name: '类型',
          value: 'type',
          type: 'select',
          width: 120,
          options: typeOptions
        },
        {
          name: '尺寸',
          value: 'size',
          type: 'select',
          width: 120,
          options: btnSize
        },
        {
          name: '事件',
          value: 'event'
        },
        {
          name: '操作',
          value: 'option',
          width: 60
        }
      ],
      event_options: [
        {label: '无', value: ''},
        {label: '保存', value: 'save'},
        {label: '删除', value: 'del'},
        {label: '复制', value: 'copy'}
      ]
    }
  },

  created() {
    this.localValue = _.cloneDeep(this.value)
    // setTimeout(() => {

    // }, 100)
  },
  watch: {
    localValue: {
      handler(newVal) {
        if (!this.isEqual(newVal, this.value)) {
          this.$emit('input', _.cloneDeep(newVal)) // 值变化时通知父级
          // this.change_value()
        }
      },
      deep: true
    },
    value: {
      handler(newVal) {
        this.localValue = _.cloneDeep(newVal)
      }
    }
  },
  methods: {
    add_to_rows(rows, item) {
      rows.push(item)
    },
    deleteRow(rows, index) {
      this.$confirm('确认删除？', '提示', {type: 'warning'})
        .then(() => rows.splice(index, 1))
        .catch(() => this.$message.info('已取消删除'))
    },
    isEqual(a, b) {
      // 智能值比对（处理所有数据类型）
      if (typeof a !== typeof b) return false
      if (typeof a === 'object' && a !== null && b !== null) {
        // 处理引用类型
        return _.isEqual(a, b) // 使用 lodash 深度比对
      }
      return a === b // 基本类型直接比对
    },
    getColumnStyle(column) {
      return {
        width: column.width ? column.width + 'px' : '',
        flex: column.width ? '' : 1
      }
    },
    getRowStyle(rowIndex) {
      return rowIndex % 2 === 0 ? {} : {'background-color': 'rgba(240, 240, 240, 0.9)'}
    }
  }
}
</script>

<style lang="scss" scoped></style>
